var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 129.72 172.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:rgba(120,120,120,0.9);stroke:white;stroke-miterlimit:40;stroke-width: 2px} .z{z-index: 2}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 17") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Container_Text",
    "data-name": "Container+Text"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1 z",
    d: "M129.2,29v130.1a12.53,12.53,0,0,1-12.53,12.53H13A12.53,12.53,0,0,1,.5,159.14V13A12.53,12.53,0,0,1,13,.5h87.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Container_Text",
    "data-name": "Container+Text"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "128.51 28.56 101.13 28.56 101.13 1.21 128.51 28.56"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperWhite);
export default __webpack_public_path__ + "static/media/paper-white.6a5946c8ba4b03f68498433ccc035698.svg";
export { ForwardRef as ReactComponent };